export default "__VITE_ASSET__DoaCIQAm__"